// extracted by mini-css-extract-plugin
module.exports = {"img":"Img_img__2lBEq","ratio":"Img_ratio__2VoRK","contain":"Img_contain__xPZy0","error":"Img_error__GbEk6","fadeIn":"Img_fadeIn__1XOda","scaleXin":"Img_scaleXin__UUEZy"};